export default __webpack_public_path__ + "static/media/face_1_18.57ed7f39.png";